<template>
  <section>
    <!-- 使用记录 -->
    <div class="pop-room" v-if="leaveStatus">
      <a href="javascript:;" @click="$emit('hideLeaveRegister')" class="iconfont icon-close"></a>
      <h3 class="title" style="padding-bottom:6px;">
        <!-- {{ userRow }} -->
        {{ userRow.name }} 的离退休登记
      </h3>

      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="120px" class="form">
          <el-form-item label="退休日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.txrq" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离职形式">
            <el-input size="small" v-model="form.lzxs" placeholder="请输入离职形式"></el-input>
          </el-form-item>
          <el-form-item label="离职日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.lzrq" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离职原因">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入离职原因" size="small"
              v-model="form.lzyy"></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-button @click="submit()" class="form-btn" type="success">确认提交</el-button>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['leaveStatus', 'userRow', 'userData'],
    components: {
      UserInfo,
    },
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        // 添加/编辑日志
        addLogStatus: false,
        form: {
          archiveId: "",
          lzrq: "",
          lzxs: "",
          lzyy: "",
          txrq: "",
        },
        selectLeader: "",

        loading: true,
      }
    },
    created() {
      this.form.archiveId = this.userRow.archivesId
      console.log(this.userRow)
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      submit() {
        ajax.post('/human/leave/position', this.form, (res) => {
          this.$message.success("离退休登记完成")
          this.$emit('hideLeaveRegister')
        })
      },
    },
    watch: {
      "userRow"() {
        this.form = {
          archiveId: this.userRow.archivesId,
          lzrq: this.userRow.lzrq ? this.userRow.lzrq : "",
          lzxs: this.userRow.lzxs ? this.userRow.lzxs : "",
          lzyy: this.userRow.lzyy ? this.userRow.lzyy : "",
          txrq: this.userRow.txrq ? this.userRow.txrq : "",
        }
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/page/personnel/leave.vue